"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasCategoryConsent = void 0;
const constants_1 = require("../constants");
/**
 * Check if consent has been given for a specific category
 * @param optanonConsent Value of OptanonConsent cookie
 * @param category Cookie category
 * @returns boolean - whether consent has been given for the category
 */
const hasCategoryConsent = (optanonConsent, category) => {
    const parts = optanonConsent.split('&');
    const groupsPart = parts.find(part => part.startsWith(constants_1.CONSENT_GROUP_PREFIX));
    if (!groupsPart) {
        return false;
    }
    const groups = groupsPart.replace(constants_1.CONSENT_GROUP_PREFIX, '').split(',');
    return groups.some(group => group === `${category}:1`);
};
exports.hasCategoryConsent = hasCategoryConsent;
